import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Landing from './components/Landing/landing.js';
import Login from './components/Auth/login.js';
import Register from './components/Auth/register.js';
import { useEffect, useState } from 'react';
import Admin from './components/Admin/admin.js';
import Bookings from './components/OnlineBooking/bookings.js';
import axios from 'axios';
import Payment from './components/OnlineBooking/Payment/payment.js';
import Confirmation from './components/OnlineBooking/Payment/confirmation.js';
import Cancellation from './components/OnlineBooking/Cancellation/cancellation.js';
import BookingError from './components/OnlineBooking/BookingError/bookingError.js';
import TermsAndConditions from './components/T&C/t&c.js';
import Verification from './components/OnlineBooking/Verification/verification';
import Pending from './components/OnlineBooking/Verification/pending';
import Maintainence from './components/OnlineBooking/Maintainence/maintainence';

// axios.defaults.headers.common["Ngrok-Skip-Browser-Warning"] = "true";

function App() {
  const [auth, setAuth] = useState(null);
  const TOTAL_COURTS = 14

  const getAuthToken = async () => {
    try {
      const token = await axios.get(`${process.env.REACT_APP_API_URL}/auth`)

      if (token.status !== 200) {
        console.log("Error fetching authentication token. Please reload the page and try again.");
        return;
      }

      setAuth(token.data)
    } catch (error) {
      console.log("Error authenticating user. Please reload the page and try again.");
    }
  }

  useEffect(() => {
    getAuthToken();
  }, []);

  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="*" element={<Landing setAuth={null} auth={{}} />} />
          {/* <Route path="/login" element={<Login />} /> */}
          {/* <Route path="/register" element={<Register />} /> */}
          {/* <Route path='/admin' element={<Admin />} /> */}
          <Route path='/online-booking' element={<Bookings totalCourts={TOTAL_COURTS} token={auth} />} />
          {/* <Route path='/online-booking' element={<Maintainence /> } />*/}
          <Route path='/terms-and-conditions' element={<TermsAndConditions />} />
          <Route path='/payment' element={<Payment />} />       
          <Route path='/booking-confirmation' element={<Confirmation />} />
          <Route path='/booking-verification' element={<Pending token={auth} />} />
          <Route path='/400' element={<BookingError code={400} />} />
          <Route path='/404' element={<BookingError code={404} />} />
          <Route path='/booking-error' element={<BookingError />} />
          <Route path='/cancel-reservation/:reservation_secret' element={<Cancellation token={auth} />} />
          <Route path='/verify-booking/:verification_secret' element={<Verification token={auth} />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;